'use es6';

const LOCALE = 'en-us';
export default (createMoment => (...args) => createMoment(...args).locale(LOCALE));